/* less/lib/less-node/fs */ function _(require, module, exports) {
    var fs;
    try {
        fs = require(112) /* graceful-fs */;
    }
    catch (e) {
        fs = require('fs');
    }
    module.exports = fs;
}
